export const route = {
    patterns: { settings: '/settings' },
    searchParams: { openPrivacyStatement: 'openPrivacyStatement' },
};
